import Cookies from 'js-cookie'
import { wareHouseInfo } from '@/global'

// 获取站点
export function getCurrentSiteEnv() {
  const curHost = window.location.hostname;
  const xjpHost = ['pulsar-wms.jd.com', 'pulsar-lwms.jd.com', 'iwms-sg.jd.com', 'pulsar-wms-gray.jd.com'];
  const euHost = ['pulsar-eu-wms.jd.com', 'pulsar-mca-wms.ochama.com', 'iwms-eu-gray.jd.com', 'iwms-eu-gray.ochama.com']
  const ggHost = ['iwms.us.jdlglobal.com', 'iwms-gray.us.jdlglobal.com']
  const ynHost = ['iwms.jd.id']
  if(xjpHost.find(item => new RegExp(item).test(curHost))){
    return 'hk'
  }
  if(euHost.find(item => new RegExp(item).test(curHost))){
    return 'hl'
  }
  if(ggHost.find(item => new RegExp(item).test(curHost))){
    return 'gg'
  }
  if(ynHost.find(item => new RegExp(item).test(curHost))){
    return 'id'
  }
  return 'test'
}

/**
 * 子午埋点
 * @param {*} code 异常code
 * @param {*} url 接口url
 * @param {Object} requestParams 请求参数
 * @param {*} msg 错误msg
 * @param {*} timeBegin 请求时间
 * @param {*} timeEnd 结束时间
 */
function addStreamLog({code, url, requestParams = {}, msg, timeBegin, timeEnd}) {
  const logParams = {
    code: code,      //异常code
    api: url,         //接口Api路径
    pageUrl: location.href,     //页面URl
    params: JSON.stringify({
      ...requestParams
    }),      //接口参数
    msg: msg,         //错误msg
    pin: Cookies.get('userCode'),  //用户pin
    requestTime: timeBegin,  //请求时间
    version: '1.0',      //前端版本
    totalTime: timeEnd - timeBegin, //接口时间
    site: Cookies.get('lwms.env') || getCurrentSiteEnv(), //站点 hk、hl、gg、id
    ...wareHouseInfo
  }
  if(process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'){
    try {
      window.log && window.log('iwms_api_log', JSON.stringify(logParams))
    } catch (error) {
      console.log(error)
    }
  }
}
export function getSite() {
  const curHost = window.location.hostname;
  const xjpHost = ['pulsar-wms.jd.com', 'pulsar-lwms.jd.com', 'iwms-sg.jd.com', 'pulsar-wms-gray.jd.com'];
  const euHost = ['pulsar-eu-wms.jd.com', 'pulsar-mca-wms.ochama.com', 'iwms-eu-gray.jd.com', 'iwms-eu-gray.ochama.com']
  const ggHost = ['iwms.us.jdlglobal.com', 'iwms-gray.us.jdlglobal.com']
  const ynHost = ['iwms.jd.com']
  if(xjpHost.find(item => new RegExp(item).test(curHost))){
    return 'XJP'
  }
  if(euHost.find(item => new RegExp(item).test(curHost))){
    return 'EU'
  }
  if(ggHost.find(item => new RegExp(item).test(curHost))){
    return 'GG'
  }
  if(ynHost.find(item => new RegExp(item).test(curHost))){
    const currentSite=Cookies.get('x-cdn-client-country-code')
    return currentSite || 'XJP'
  }
  return 'XJP'
}




export default addStreamLog